import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from "./util/http"
import jssdk from "weixin-js-sdk"
import global from "./util/global"

//ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(MintUI)

//axios
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.prototype.$http = http
Vue.prototype.$wx = jssdk
Vue.prototype.global = global

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
